import request from '@/utils/request'

// 조회
export function getRiskAssessmentProcesses (params,isProgress) {
  return request({
    url: `/api/getRiskAssessmentProcesses`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 조회
export function getRiskAssessments (params,isProgress) {
  return request({
    url: `/api/getRiskAssessments`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
// 조회
export function getProcessShInfo (params,isProgress) {
  return request({
    url: `/api/getProcessShInfo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
// 예시 조회
export function getProcessShInfoSample (params,isProgress) {
  return request({
    url: `/api/getProcessShInfoSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
// export function getWorkDetails (params,isProgress) {
//   return request({
//     url: `/api/getWorkDetails`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data: params,
//     Notify: { use: isProgress, apitype: 'searched' },
//   })
// }
// 공정 적용 저장
export function saveRiskAssessments (params,isProgress) {
  return request({
    url: `/api/saveRiskAssessments`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

export function saveRiskAssessmentShInfo (params,isProgress) {
  return request({
    url: `/api/saveRiskAssessmentShInfo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

// 작업 내용 상세 저장
// export function saveRiskAssessmentWorks (params,isProgress) {
//   return request({
//     url: `/api/saveRiskAssessmentWorks`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data: params,
//     Notify: { use: isProgress, apitype: 'saved' },
//   })
// }

// 출력물
export function getRiskAssessmentProcessReport (params,isProgress) {
  let responseType = 'blob'
  return request({
    url: `/api/getRiskAssessmentProcessReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function getCompanyProcesses (params,isProgress) {
  return request({
    url: `/api/getCompanyProcesses`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function getCompanyWorks (params,isProgress) {
  return request({
    url: `/api/getCompanyWorks`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
